import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: `button-save`,
  template: `
    <button class="btn btn-success d-print-none {{btnClass}}" (click)="onClick()" type="button" [disabled]="disabled"
            aria-label="Save" ngbTooltip="Save">
      <i class="fa fa-floppy-o" aria-hidden="true"></i> {{ label }}
    </button>    `
})
export class SavebuttonComponent {
  @Output() btnClick = new EventEmitter();
  @Input() disabled = false;
  @Input() btnClass = '';
  @Input() label = '';

  onClick(): void {
    this.btnClick.emit();
  }
}
